<template>
    <div>
        <vue-element-loading :active="loading" spinner="bar-fade-scale" color="#FF6700"/>
        <g-filters ref="g-filters" :save="save" @save="saveAsData" @search="(val) => {loading=val}" @table="setData"></g-filters>
        <br>
        <vue-good-table
            v-if="rows.length"
            :select-options="selectOptions"
            @on-selected-rows-change="selectionChanged"
            @on-row-dblclick="handleRowDoubleClick"
            @on-row-click="handleRowClick"
            :columns="columns"
            :sort-options="{
                    enabled: true,
                    initialSortBy: {field:  columns[order].field, type: 'asc'}
                  }"
            :rows="rows">
        </vue-good-table>
    </div>
</template>

<script>
import GFilters from "./g-filters";
import VueElementLoading from "vue-element-loading";

export default {
    name: "GenericSelect",
    props: {
        model: {
            type: String
        },
        order: {
            type: Number,
            default: 0
        },
        save: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            columns: [],
            rows: [],
            selecteds: [],
            loading: false,
            selectOptions: {
                enabled: true,
                selectOnCheckboxOnly: true,
            },
        };
    },
    components: {VueElementLoading, GFilters},
    methods: {

        saveAsData(obj){
            this.$emit('dataSave', obj)
        },
        selectionChanged(params) {
            this.selecteds = params.selectedRows.map(function (obj) {
                return obj.id;
            })

            this.$emit('selecteds', this.selecteds)
        },
        handleRowDoubleClick(row) {
            this.selecteds = [row.row.id];
            this.$emit('selecteds', this.selecteds)
            this.$emit('apply')
        },
        handleRowClick(row){

        },
        getRecords() {
            let app = this;
            let ids = this.ids.map(function (el, index) {
                return `ids[${index}]=${el}`
            }).join('&');
            axios.get(`//list-of-ids?${ids}`).then((response) => {
                app.columns = response.data.columns
                app.rows = response.data.rows
                app.getColumnsStore()
            })
                .catch((err) => {
                    showMessage('e', 'Error loading');
                    console.error(err);
                })
        },
        setData(cols, rows) {
            this.columns = cols;
            this.rows = rows;
            this.loading = false;
        },

        getData() {
            this.$refs["g-filters"].getData()
        }
    }


}
</script>

<style scoped>

</style>
